export default __webpack_public_path__ + "static/1.1_IT-2e719533bfad22bce1bb102c9e4b8811.webp";